module.exports = __webpack_public_path__ + "img/570a.eb30b960.png";